/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateEnabledPayersBulkRequest
 */
export interface UpdateEnabledPayersBulkRequest {
    /**
     * 
     */
    payers_to_enable?: Array<string>;
    /**
     * 
     */
    payers_to_disable?: Array<string>;
}

/**
 * Check if a given object implements the UpdateEnabledPayersBulkRequest interface.
 */
export function instanceOfUpdateEnabledPayersBulkRequest(value: object): value is UpdateEnabledPayersBulkRequest {
    return true;
}

export function UpdateEnabledPayersBulkRequestFromJSON(json: any): UpdateEnabledPayersBulkRequest {
    return UpdateEnabledPayersBulkRequestFromJSONTyped(json, false);
}

export function UpdateEnabledPayersBulkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEnabledPayersBulkRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'payers_to_enable': json['payers_to_enable'] == null ? undefined : json['payers_to_enable'],
        'payers_to_disable': json['payers_to_disable'] == null ? undefined : json['payers_to_disable'],
    };
}

export function UpdateEnabledPayersBulkRequestToJSON(json: any): UpdateEnabledPayersBulkRequest {
    return UpdateEnabledPayersBulkRequestToJSONTyped(json, false);
}

export function UpdateEnabledPayersBulkRequestToJSONTyped(value?: UpdateEnabledPayersBulkRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payers_to_enable': value['payers_to_enable'],
        'payers_to_disable': value['payers_to_disable'],
    };
}

